import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { PipesModule } from "../../pipes/pipes.module";
import { AppDirectivesModule } from "../app-directives/app-directives.module";

import { AppEditorComponent } from "./app-editor.component";
import { AutoFillComponent2 } from "../../components/auto-fill-2/auto-fill-2.component";
import { AssetTagsComponent } from "../../components/asset-tags/asset-tags.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    AppDirectivesModule
  ],
  declarations: [
    AppEditorComponent,
    AutoFillComponent2,
    AssetTagsComponent
  ],
  exports: [
    AppEditorComponent,
    AutoFillComponent2,
    AssetTagsComponent
  ],
  providers: [
  ]
})

export class AppEditorModule {}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/modules/app-editor/app-editor.module.ts